<template>
  <div
    class="banner-container"
    v-if="list.length"
  >
    <div class="swiper-wrap">
      <div
        class="main-swiper"
        v-swiper="swiperOption"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(banner, index) in list"
            :key="index"
          >
            <img
              class="banner-item"
              :src="banner.img"
            >
          </div>
        </div>
      </div>
    </div>

    <div
      id="thumbs"
      v-if="list.length"
      v-swiper="thumbsSwiperOption"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          :class="{'active': index === currIndex}"
          v-for="(banner, index) in list"
          :key="index"
        >
          <img
            class="banner-item"
            :src="banner.img"
          >
        </div>
      </div>
    </div>

    <div class="button-prev button">
      <svg
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#icon-zuo"></use>
      </svg>
    </div>

    <div class="button-next button">
      <svg
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#icon-you"></use>
      </svg>
    </div>

    <div
      class="button-thumbs-prev button-thumbs"
      v-show="list.length > 6"
    >
      <svg
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#icon-zuoqiehuan"></use>
      </svg>
    </div>

    <div
      class="button-thumbs-next button-thumbs"
      v-show="list.length > 6"
    >
      <svg
        class="icon"
        aria-hidden="true"
      >
        <use xlink:href="#icon-youqiehuan"></use>
      </svg>
    </div>

    <div
      class="close"
      :class="{'ani': activeAnimation}"
      @click="handleClose"
    >
      <svg
        class="icon"
        style="width: 32px; height: 32px;"
        aria-hidden="true"
      >
        <use xlink:href="#icon-guanbi"></use>
      </svg>
    </div>

    <p class="num">
      <span class="num-child">{{handlePaddingZero(currIndex + 1)}}</span><span class="vline">|</span><span
        class="num-child"
      >{{handlePaddingZero(list.length)}}</span>
    </p>
  </div>
</template>

<script>
import Vue from 'vue'

if (process.client) {
  const VueAwesomeSwiper = require('vue-awesome-swiper')
  Vue.use(VueAwesomeSwiper)
}

let vm = null

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      currIndex: 0,
      isClick: false,
      isTransition: false,
      isThumbTransition: false,
      activeAnimation: false,
      swiperOption: {
        threshold: 10,
        speed: 400,
        direction: 'horizontal',
        paginationClickable: true,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
          disabledClass: 'button-disabled'
        },
        on: {
          slideChange: function () {
            if (vm.isClick) {
              return
            }

            if (vm.isThumbTransition) {
              return
            }

            console.log('swiper', this.activeIndex)

            vm.isTransition = true

            vm.thumbs.slideTo(this.activeIndex, 400)
            vm.handleClickSlide(this.activeIndex)

            vm.$nextTick(() => {
              vm.isTransition = false
            })
          }
        }
      },
      thumbsSwiperOption: {
        threshold: 10,
        speed: 400,
        paginationClickable: true,
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 3,
        spaceBetween: 7,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: '.button-thumbs-next',
          prevEl: '.button-thumbs-prev',
          disabledClass: 'button-disabled'
        },
        on: {
          click: function () {
            if (vm.isTransition) {
              return
            }

            if (vm.isThumbTransition) {
              return
            }

            console.log('click', this.clickedIndex)

            vm.isClick = true
            vm.$swiper.slideTo(this.clickedIndex, 400)
            vm.thumbs.slideTo(this.clickedIndex, 400)
            vm.handleClickSlide(this.clickedIndex)

            vm.$nextTick(() => {
              vm.isClick = false
            })
          },
          slideChange: function () {
            if (vm.isClick) {
              return
            }

            if (vm.isTransition) {
              return
            }

            console.log('thumb', this.activeIndex, vm.isTransition)

            vm.isThumbTransition = true

            const index = this.activeIndex * 6
            vm.$swiper.slideTo(index, 400)
            vm.handleClickSlide(index)

            vm.$nextTick(() => {
              vm.isThumbTransition = false
            })
          }
        }
      }
    }
  },

  created () {
    vm = this
  },

  methods: {
    handleClickSlide (reindex) {
      const item = this.list.find(
        (item, itemIndex) => itemIndex === reindex
      )

      this.currIndex = reindex
      this.$emit('change-item', item)
    },

    handlePaddingZero (num) {
      return num < 10 ? `0${num}` : num
    },

    handleClose () {
      this.activeAnimation = true

      setTimeout(() => {
        this.activeAnimation = false
        window.close()
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  position: relative;
  width: 1012px;

  .swiper-wrap {
    overflow: hidden;
    width: 100%;
    height: 660px;
  }

  ::v-deep {
    #thumbs {
      position: absolute;
      bottom: 2px;
      left: -268px;
      width: 250px;
      height: 158px;
    }

    #thumbs .swiper-slide {
      height: auto !important;
      opacity: 0.5;
      filter: brightness(0.6);

      &.active {
        opacity: 1;
        filter: brightness(1);
      }
    }
  }

  .main-swiper {
    .banner-item {
      width: 1012px;
      height: 660px;

      object-fit: contain;
    }
  }

  #thumbs {
    overflow: hidden;
    box-sizing: border-box;

    .banner-item {
      box-sizing: border-box;
      width: 70px;
      height: 70px;

      object-fit: cover;
    }
  }

  .button {
    position: absolute;
    top: 300px;
    z-index: 100;
    cursor: pointer;
  }

  .button-prev {
    left: 55px;
  }

  .button-next {
    right: 55px;
  }

  .button-thumbs {
    position: absolute;
    bottom: 70px;
    z-index: 100;
    cursor: pointer;
  }

  .button-thumbs-prev {
    left: -320px;
  }

  .button-thumbs-next {
    left: 0px;
  }

  .button-disabled {
    opacity: 0.3;
    cursor: default;
  }

  .num {
    position: absolute;
    right: -20px;
    bottom: 0;
    display: flex;
    align-items: center;
    color: #000000;

    .num-child {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
    }

    .vline {
      margin: 0 3px;
    }
  }

  .close {
    position: absolute;
    top: 0;
    right: -20px;
    z-index: 10;
    color: #5e5e5e;
    cursor: pointer;
  }

  .ani {
    animation: rotate90 0.3s forwards;
  }

  @keyframes rotate90 {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(90deg);
    }
  }
}
</style>
